import styled from 'styled-components';

import { px } from '../../../contrib/ui';

export const HomeStyled = styled.div`
  flex-direction: column;
  background-color: #eeeeef;

  .main-title {
    .title-container {
      h2,
      .desc {
        text-shadow: 0 1px 2px #fff;
      }

      h2 {
        font-family: 'DINNextLTPro-Heavy';
        font-size: ${px(30)};
        line-height: 1em;
        margin-bottom: 0.1em;
        color: white;
        text-shadow: 0 1px 2px #000;
        margin: 0;

        &.darker {
          color: var(--dark);
          text-shadow: 0 1px 2px #fff;
        }
      }

      .desc {
        font-family: 'DINNextLTPro-Bold';
        font-size: ${px(14)};
        line-height: 1.21em;
        margin-top: ${px(10)};
        text-align: center;
      }
    }
  }

  & > div {
    justify-content: flex-start;
  }

  .player-subheader-container {
    .main-title {
      .title-container {
        top: ${px(50)};
      }

      .mask {
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, var(--greyee) 100%);
        width: 100%;
        height: 100%;
        position: absolute;
      }
    }
  }
`;

export const CardsContainerStyled = styled.div`
  margin-top: ${px(-80)};
  width: 100%;
  z-index: 2;
`;
